import React, { FC } from "react";

interface ActionButtonProps {
    action: ButtonActions;
    isDisabled: boolean;
    showSpinner?: boolean;
    handleClick: Function;
}

export const ActionButton: FC<ActionButtonProps> = ({action, isDisabled, showSpinner = false, handleClick}) => {
  let buttonClassName: string = "player-button";
  if(action === ButtonActions.PLAY || action === ButtonActions.RESUME){
    buttonClassName += " " + "icon-play play";
  }
  else if(action === ButtonActions.PAUSE){
    buttonClassName += " " + "icon-pause pause";
  }
  else if(action === ButtonActions.STOP){
    buttonClassName += " " + "icon-stop stop";
  }

  return(
    showSpinner ?
      <div className="player-button player-spinner-container">
        <div className="player-spinner"></div>
      </div>
      :
      <button className={buttonClassName} title={action} disabled={isDisabled} onClick={(event) => handleClick(event,action)} />
  );

};

export enum ButtonActions{
    PLAY = "Play",
    PAUSE = "Pause",
    RESUME = "Resume",
    STOP = "Stop"
  }